import styled from 'styled-components';

const Label = styled.div`
  letter-spacing: 0;
  padding: 10px 0;
`;

export default Label;
